import type { StylesConfig } from "react-select"

export const reactSelectStyles: StylesConfig = {
  control: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "var(--ct-dropdown-bg)",
    borderColor: "var(--ct-dropdown-border-color)",
    borderRadius: "var(--ct-border-radius)",
  }),
  menu: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "var(--ct-dropdown-menu-bg)",
  }),
  menuList: (baseStyles) => ({
    ...baseStyles,
    padding: 0,
  }),
  option: (baseStyles, state) => ({
    ...baseStyles,
    color: state.isSelected ? "var(--ct-body-color)" : undefined,
    backgroundColor:
      state.isFocused && !state.isSelected
        ? "var(--ct-dropdown-option-bg)"
        : state.isSelected
        ? "var(--ct-dropdown-option-bg-selected)"
        : undefined,
    ":active": {
      ...baseStyles[":active"],
      backgroundColor: state.isFocused ? "var(--ct-dropdown-option-bg-active)" : undefined,
    },
  }),
  multiValue: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "var(--ct-dropdown-option-bg)",
    color: "var(--ct-color-main)",
  }),
  multiValueLabel: (baseStyles) => ({
    ...baseStyles,
    color: "var(--ct-color-main)",
  }),
  indicatorSeparator: (baseStyles) => ({
    ...baseStyles,
    backgroundColor: "var(--ct-dropdown-border-color)",
  }),
  input: (baseStyles) => ({
    ...baseStyles,
    color: "var(--ct-color-main)",
  }),
  singleValue: (baseStyles) => ({
    ...baseStyles,
    color: "var(--ct-color-main)",
  }),
}
